import { render, staticRenderFns } from "./VTextArea.vue?vue&type=template&id=2bf286a1&scoped=true"
import script from "./VTextArea.vue?vue&type=script&lang=js"
export * from "./VTextArea.vue?vue&type=script&lang=js"
import style0 from "./VTextArea.vue?vue&type=style&index=0&id=2bf286a1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf286a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf286a1')) {
      api.createRecord('2bf286a1', component.options)
    } else {
      api.reload('2bf286a1', component.options)
    }
    module.hot.accept("./VTextArea.vue?vue&type=template&id=2bf286a1&scoped=true", function () {
      api.rerender('2bf286a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VTextArea.vue"
export default component.exports